import { Sections } from "../../../constants/sections"
import { UserRoles as ConstantUserRoles } from "../../../constants/user"

const UserRoles = [
    { id: ConstantUserRoles.BASIC, name: 'Básico' },
    { id: 'SUPERVISOR', name: 'Supervisor' },
    { id: ConstantUserRoles.ATS_ADMIN, name: 'Administrador de ATS' },
    { id: ConstantUserRoles.DELEGATE, name: 'Usuario delegado' },
    { id: 'READ_ONLY', name: 'Solo lectura' }
]

const TechnicalUserRoles = [
    { id: ConstantUserRoles.BASIC, name: 'Personalizado' },
    { id: ConstantUserRoles.ATS_ADMIN, name: 'Administrador de ATS' },
    { id: 'READ_ONLY', name: 'Solo lectura' },
    { id: ConstantUserRoles.DELEGATE, name: 'Usuario delegado' },
]

const UserAuthorizedSections = [
    {id: Sections.Inbox, name: 'Inbox'},
    {id: Sections.JobOffer, name: 'Jobs'},
    {id: Sections.PushOffer, name: 'Ofertas Push'},
    {id: Sections.PullConfig, name: 'Configuración Pull'},
    {id: Sections.SavedSearches, name: 'Búsquedas guardadas'},
    {id: Sections.Planning, name: 'Planificación'},
    {id: Sections.Favorites, name: 'Favoritos'},
    {id: Sections.Reports, name: 'Informes'},
    {id: Sections.StatisticsDashboard, name: 'Dashboard estadísticas'},
    {id: Sections.JobflowEvaluation, name: 'Jobflows'},
    {id: Sections.Multiposting, name: 'Multiposting'},
    {id: Sections.RPAConfig, name: 'Fuentes de reclutamiento'},
    {id: Sections.EvaluativeTests, name: 'Video entrevistas'},
    {id: Sections.GPPRequestor, name: 'GPP - Creador de peticiones'},
    {id: Sections.GPPValidator, name: 'GPP - Validador de peticiones'},
    {id: Sections.GIPPRequestor, name: 'GIPP - Creador de peticiones'},
    {id: Sections.GIPPValidator, name: 'GIPP - Validador de peticiones'},
]

const ATSUserAuthorizedSections = [
    {id: Sections.JobflowEvaluation, name: 'Jobflows'},
    {id: Sections.Multiposting, name: 'Multiposting'},
    {id: Sections.EvaluativeTests, name: 'Video entrevistas'},
]

export {UserRoles, TechnicalUserRoles, UserAuthorizedSections, ATSUserAuthorizedSections}
